const plantaskDict = {
  data() {
    return {
      dictData: {
        formType2: [
          { value: 'visit', title: '待回访型' },
          { value: 'sync', title: '业务内推型' },
          { value: 'notice', title: '运营型回访提醒' },
          { value: 'interview', title: '面试时间提醒' },
          { value: 'public', title: '公海型' },
        ],
        formType3: {
          visit: [
            { title: '等待处理', remark: '未及时修改用户分级和没有回访记录的会被标记', value: 'visit-1' },
            { title: '联系中', remark: '24小时内没有回访的用户会被标记', value: 'visit-2' },
            { title: '犹豫中', remark: '30天没有回访的用户会被标记', value: 'visit-3' },
            { title: '有意向', remark: '7天没有回访的用户会被标记', value: 'visit-4' },
          ],
          sync: [
            { title: '24h待回访', remark: '24小时内没有回访的用户会被标记', value: 'sync-1' }
          ],
          notice: [
            { title: '24h待回访', remark: '24小时内没有回访的用户会被标记', value: 'notice-1' }
          ],
          interview: [
            { title: '当天面试记录', remark: '当天有面试的学生会展示', value: 'interview-1' }
          ],
          public: [
            { title: '联系中', remark: '15天内没有回访的用户会被标记', value: 'public-1' },
            { title: '长期跟进', remark: '180天内没有回访的用户会被标记', value: 'public-2' },
          ],
        }
      },
    };
  },
  computed: {
    dict() {
      let dictData = Object.assign({}, this.dictData);
      let roleid = 0;
      if (this.searchData && this.searchData.roleid) {
        roleid = this.searchData.roleid;
      }
      // console.log('roleid', roleid);
      if (!this.checkPermission([20], roleid)) {
        // console.log('不是日本咨询');
        // 不是日本咨询——去掉面试时间提醒大类型
        dictData.formType2 = dictData.formType2.filter((d) => {
          return d.value !== 'interview';
        });
      }
      if (this.checkPermission([129], roleid) && !this.checkPermission([81], roleid)) {
        // 高考日语线上咨询去掉犹豫中列表
        dictData.formType3.visit = dictData.formType3.visit.filter((d) => {
          return ['visit-3', 'visit-4'].indexOf(d.value) === -1;
        });
        // 去掉内推
        dictData.formType2 = dictData.formType2.filter((d) => {
          return d.value !== 'sync';
        });
        dictData.formType3.visit.push({ title: '有意向', remark: '2天内没有回访的用户会被标记', value: 'visit-4' });
        dictData.formType3.visit.push({ title: '长期跟进', remark: '15天内没有回访的用户会被标记', value: 'visit-5' });
      }
      return dictData;
    }
  },
  methods: {
    checkPermission(perList, roleid = 0) {
      let result = false;
      if (roleid && perList.indexOf(roleid) !== -1) {
        result = true;
      } else {
        result = this.$hasPermission(perList);
      }
      return result;
    }
  }
};
export default plantaskDict;
